module.exports = __webpack_public_path__ + "img/登录页logo.7f70232f.png";